/* eslint-disable react/prop-types */
import React from "react";
import { makeStyles } from "@material-ui/core";
import { AiFillInfoCircle } from "react-icons/ai";
import ConfirmationDialog from "./ConfirmationDialog";

const useStyles = makeStyles(() => ({
  centeredText: {
    textAlign: "center",
  },
  infoIcon: {
    fontSize: "5rem",
    color: "#999999",
  },
  "& @keyframes popup": {
    "15%, 40%, 75%, 100% ": {
      "transform-origin": "center center",
    },
    "15%": {
      transform: "scale(1.2, 1.1)",
    },
    "40%": {
      transform: "scale(0.95, 0.95)",
    },
    "75%": {
      transform: "scale(1.05, 1)",
    },
    "100%": {
      transform: "scale(1, 1)",
    },
  },
}));

export default function BadRequestDialog({ open = true }) {
  const classes = useStyles();
  return (
    <ConfirmationDialog
      open={open}
      title={<br />}
      isCancelComponent={false}
      confirmText="Refresh"
      onConfirmAction={() => window.location.reload(true)}
      isInAnimation
      content={
        <div className={classes.centeredText}>
          <AiFillInfoCircle className={classes.infoIcon} />
          <h1>Oops! Something went wrong...</h1>
          <h3>Please refresh the page and try again.</h3>
        </div>
      }
    />
  );
}
